import {isChooseMultipleSeatsMode, isChooseSeatMode} from '../../../../../selectors/navigation'
import {getShowDescriptionPlace, isInAccessibilityMode, isInDescription} from '../../../../../selectors/seating/mode'
import {getPlacesInBasket, getPlacesInBasketCount} from '../../../../../selectors/seating/places'
import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {SidebarOwnProps, SidebarRuntimeProps} from './interfaces'
import {Sidebar as Presentation} from './sidebar'

const mapRuntime = ({state}: DetailsPageAppProps): SidebarRuntimeProps => ({
  showAccessibilityMode: isInAccessibilityMode(state),
  chooseSeatMode: isChooseSeatMode(state),
  chooseMultipleSeatsMode: isChooseMultipleSeatsMode(state),
  placesInBasketCount: getPlacesInBasketCount(state),
  placesInBasket: getPlacesInBasket(state),
  showSeatDescription: isInDescription(state),
  descriptionPlace: getShowDescriptionPlace(state),
})

export const Sidebar = connect<SidebarOwnProps, SidebarRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
